import { combineReducers } from 'redux';
import Settings from './Settings';
import ChatData from './Chat';
import Contact from './Contact';
import Mail from './Mail';
import ToDo from './ToDo';
import Auth from './Auth';
import Organisation from './Organisation';
import Employee from './Employee';
import OrgSurvey from './OrgSurvey';
import OrgSurveyAnswer from './OrgSurveyAnswer';
import SurveyGroup from './SurveyGroup';
import Survey from './Survey';
import SurveyQuestion from './SurveyQuestion';
import SurveyGroupQuestion from './SurveyGroupQuestion';
import Project from './project';
import ProjectPriority from './projectPriority';
import Security from './security';
import ProjectIssue from './projectIssue';
import BusinessUnit from './businessUnit';
import Portfolio from './portfolio';
import Feature from './feature';
import ValueStream from './valueStream';
import Member from './member';
import Team from './team';
import Product from './product';
import Initiative from './initiative';
import Issue from './issue';
import ProjectBusPriority from './projectBusPriority';
import ProjectCostPriority from './projectCostPriority';

const reducers = combineReducers ({
    settings: Settings,
    chatData: ChatData,
    contacts: Contact,
    mail: Mail,
    toDo: ToDo,
    auth: Auth,
    orgs: Organisation,
    emps: Employee,
    orgSurveys: OrgSurvey,
    orgSurveyAnswers: OrgSurveyAnswer,
    surveys: Survey,
    surveyGroups: SurveyGroup,
    surveyQuestions: SurveyQuestion,
    surveyGroupQuestions: SurveyGroupQuestion,
    projects: Project,
    projectPrioritys: ProjectPriority,
    securitys: Security,
    projectIssues: ProjectIssue,
    businessUnits: BusinessUnit,
    portfolios: Portfolio,
    features: Feature,
    valueStreams: ValueStream,
    members: Member,
    teams: Team,
    products: Product,
    initiatives: Initiative,
    issues: Issue,
    projectBusPrioritys: ProjectBusPriority,
    projectCostPrioritys: ProjectCostPriority,
});

export default reducers;



// WEBPACK FOOTER //
// ./reducers/index.js